var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDisabledStageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13H16.875",
    stroke: "#D8D8D8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 15.5L16.875 13",
    stroke: "#D8D8D8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 10.5L16.875 13",
    stroke: "#D8D8D8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisabledStageGrey);
export default __webpack_public_path__ + "static/media/Icon_DisabledStage_Grey.f6902a0d913786657fc465febba4b529.svg";
export { ForwardRef as ReactComponent };